import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand } from 'lexical';
import { useEffect } from 'react';

import { $createVideoNode } from '../Nodes/VideoNode';

export const INSERT_VIDEO_COMMAND = createCommand('INSERT_VIDEO_COMMAND');

const VideoPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const cleanup = editor.registerCommand(
      INSERT_VIDEO_COMMAND,
      (payload) => {
        editor.update(() => {
          const node = $createVideoNode(payload);

          $insertNodes([node]);
        });

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );

    return () => {
      cleanup();
    };
  }, [editor]);

  return null;
};

export default VideoPlugin;
